import { useState, useCallback, useEffect } from 'react';
import { getConsentValues } from '../services/consentCookieService.js';
import { getPixels } from '../services/pixelService.js';
import useConsentApplied from './useConsentApplied.js';
import useLoadExecutions from './useLoadExecutions.js';
import useLoadSources from './useLoadSources.js';

const usePixelExecutor = (site) => {
    const [requestParams, setRequestParams] = useState(undefined);
    const [totalToLoad, setTotalToLoad] = useState(undefined);
    const cookieConsentApplied = useConsentApplied();
    const { pendingSources, loadPendingSources } = useLoadSources();
    const { loadExecutions } = useLoadExecutions();
    const applyPixels = useCallback((params) => {
        (async () => {
            const pixels = await getPixels({
                site,
                ...params,
                acceptedConsents: getConsentValues(),
                pixelData: {
                    siteId: String(site),
                    ...requestParams,
                },
            });
            if (pixels) {
                loadPendingSources(pixels.sources);
                setTotalToLoad(pixels);
            }
        })();
    }, [loadPendingSources, requestParams, site]);
    useEffect(() => {
        if (cookieConsentApplied && requestParams) {
            applyPixels(requestParams);
        }
    }, [cookieConsentApplied, requestParams, applyPixels]);
    useEffect(() => {
        if (totalToLoad && pendingSources.length === 0) {
            loadExecutions(totalToLoad.executions);
            setTotalToLoad(undefined);
        }
    }, [pendingSources, totalToLoad, loadExecutions]);
    return { executePixels: setRequestParams };
};

export { usePixelExecutor as default };
//# sourceMappingURL=usePixelExecutor.js.map
